import React from 'react';
import { Alert, Button, Result } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('管理端页面渲染失败', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Result
        status="500"
        title="页面加载失败"
        subTitle="页面遇到了意外错误，您可以刷新后重试。"
        extra={[
          <Button type="primary" key="reload" onClick={() => window.location.reload()}>
            刷新页面
          </Button>,
          <Button key="home" onClick={() => { window.location.href = '/'; }}>
            返回首页
          </Button>,
        ]}
      >
        {process.env.NODE_ENV === 'development' && (
          <Alert type="error" showIcon message={this.state.error.message} />
        )}
      </Result>
    );
  }
}

export default ErrorBoundary;
